export default "__VITE_ASSET__N0OvnRKQ__"